// src/redux/userSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_URL } from '../config/apiUrl'; // Adjust path if needed

// The async action to fetch data
export const fetchUserCredits = createAsyncThunk(
  'user/fetchCredits',
  async (token, { rejectWithValue }) => {
    if (!token) {
      return rejectWithValue('No session token provided');
    }
    try {
      const response = await axios.get(`${API_URL}/api/user/usage`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data.credits_available;
    } catch (error) {
      // Failed to fetch credits
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch credits'
      );
    }
  }
);

const initialState = {
  credits: null,
  status: 'idle',
  error: null,
};

// The slice that manages the state
const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchUserCredits.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchUserCredits.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.credits = action.payload;
        // state.credits = action.payload;
      })
      .addCase(fetchUserCredits.rejected, (state, action) => {
        state.status = 'failed';
        state.credits = null;
        state.error = action.payload;
      });
  },
});

// The single default export for this file
export default userSlice.reducer;
